/*
// TODO: QA this GREATLY
const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

if(window.localStorage.getItem("klaviyoOnsite")){
  let ls_klaviyo = JSON.parse(window.localStorage.getItem("klaviyoOnsite"))
  if(!isEmptyObject(ls_klaviyo.viewedForms.modal.viewedForms) && !isEmptyObject(ls_klaviyo.viewedForms.modal.disabledForms)){
    console.log("klaviyo modal has been launched AND dismissed, so remove Postscript scripts");
    waitUntil(() => {
      return document.querySelectorAll('#ps-sdk-loader').length > 0;
    }).then(() => {
      document.querySelector('#ps-sdk-loader').remove();
      console.log("remove #ps-sdk-loader");
    }).catch();
    waitUntil(() => {
      return document.querySelectorAll('#ps__widget_container').length > 0;
    }).then(() => {
      console.log("remove #ps__widget_container");
      document.querySelector('#ps__widget_container').remove();
    }).catch();
  }
}
*/



let cart_contains_sub = false;
let cart_total_over_40 = false;
let cart_total_over_50 = false;
let cart_total_over_70 = false;

let cart_total = 0;
let threshold_percentage = 0;
let starting_threshold_percentage = 0;

waitForElement('#cart-total-price').then(el => {
  let starting_cart_val = el.getAttribute("data-cart-price");
  threshold_percentage = starting_cart_val / 7000 * 100;
  starting_cart_val >= 4000 ? cart_total_over_40 = true : cart_total_over_40 = false;
  starting_cart_val >= 5000 ? cart_total_over_50 = true : cart_total_over_50 = false;
  starting_cart_val >= 7000 ? cart_total_over_70 = true : cart_total_over_70 = false;
})

if (getParam("cart-open")) {
  document.addEventListener("rebuy:smartcart.ready", function (event) {
    window.Rebuy.SmartCart.show();
  });
}

// auto apply discount codes
document.addEventListener('cart:updated', function (event) {
  var cart = event.detail.cart;
  cart_total = cart.total_price;

  // let cart_contains_duplicates = false;

  cart.total_price >= 4000 ? cart_total_over_40 = true : cart_total_over_40 = false;
  cart.total_price >= 5000 ? cart_total_over_50 = true : cart_total_over_50 = false;
  cart.total_price >= 7000 ? cart_total_over_70 = true : cart_total_over_70 = false;

  // the last item overrides any other auto-apply discount code that may be set
  for (let i = 0; i < cart.items.length; i++) {
    if (cart.items[i].selling_plan_allocation) {
      // newsubsave50 WAS the OG method to apply first time savings in RC, but it looks like this is now a line item discount applied via selling_plan
      // window.sessionStorage.setItem("auto-apply-discount", "newsubsave50");
      // document.documentElement.classList.add("js-auto-discount-active");
      cart_contains_sub = true;
      break;
    } else {
      if (i == cart.items.length - 1) {
        // window.sessionStorage.setItem("auto-apply-discount", "");
        // document.documentElement.classList.remove("js-auto-discount-active");
      }
    }
  }

  /* presidents day sale */
  if (window.sessionStorage.getItem("presidents-day")) {

    starting_threshold_percentage = threshold_percentage;
    threshold_percentage = (cart.total_price / 7000) * 100;

  }

  console.log("cart updated", `cart_contains_sub: ${cart_contains_sub} -- cart_total_over_50: ${cart_total_over_50}`);

});

document.addEventListener("DOMContentLoaded", () => {

  if (window.location.href.indexOf("/cart") > -1) {
    window.location = "/collections/all?cart-open=true";
  }

  //HRN-27v0 is 25off new subs, which WAS PREVIOUSLY set via Ruby script and is NOW offered via discount code
  // window.sessionStorage.setItem("auto-apply-discount", "SAVE25NEWSUB");

  /*
  the savings verbiage exists in these places:
  - mini cart
  - collection cards
  - pdp
  */

  if (window.sessionStorage.getItem("auto-apply-discount")) {
    document.documentElement.classList.add("js-auto-discount");
  }

  /*
  observeSelector('.line-item__discount-badge.discount-badge', badge => {
    if(!window.sessionStorage.getItem("HRN-27")){
      //v0
      badge.querySelector('span').innerHTML = "1-time savings (25% off)";
    } else {
      //v1
      badge.querySelector('span').innerHTML = "1-time savings (50% off)";
    }
    // let line_price = badge.closest('.line-item__content-wrapper').querySelector('.price--highlight .price--value');
    //let adjusted_price = parseInt(line_price.getAttribute("data-value"))*(2/3);
    badge.closest('line-item').classList.add("js-totals-at-checkout");
  });

  waitUntil(() => {
    return window.sessionStorage.getItem("HRN-27") || getParam("qa") == "HRN-27";
  }).then(() => {
    window.sessionStorage.setItem("HRN-27", "v1");

    init_experiment("HRN-27", "0.01", "v1");
    window.sessionStorage.setItem("auto-apply-discount", "SAVE50NEWSUB");

  }).catch();
  */

  waitUntil(() => {
    return window.sessionStorage.getItem("HRN-21") || getParam("qa") == "hrn21";
  }).then(() => {
    if (getParam("qa") == "hrn21") {
      window.sessionStorage.setItem("HRN-21", "v1");
    }

    init_experiment("HRN-21", "0.04", "v1");

    const apply_hrn21v1 = () => {

      waitUntil(() => {
        return document.querySelectorAll('product-list product-item:not(.js-hrn21-applied) .product-item__subscription-upsell').length > 0;
      }).then(() => {

        //upsell treatment activated

        console.log("apply_hrn21v1()");

        document.querySelector('body').insertAdjacentHTML("afterbegin", `
          <style>
            .js-hidden{
              position: absolute;
              left: -9999px;
              pointer-events: none;
              display: none;
              opacity: 0;
            }
            .hrn21v1 product-facet product-list product-item{
              padding-bottom: 0 !important;
            }
            .hrn21v1 product-facet product-list product-item .product-item__actions-row{
              flex-wrap: wrap;
            }
            .hrn21v1 product-facet product-list product-item .product-item__actions-row .col--50{
              width: 100%;
            }
            .hrn21v1 product-facet product-list .product-item__subscription-upsell form{
              position: static !important;
              margin-top:.75rem;
            }
            .hrn21v1 product-facet product-list .product-item__subscription-upsell hr, .hrn21v1 product-facet product-list .product-item__subscription-upsell p, .hrn21v1 product-facet product-list .product-item__actions-row > div > a{
              display: none !important;
            }

            .hrn21v1 product-facet product-list .product-item .product-item-meta__reviews-badge{
              position: absolute;
              top:-2px;
              right: 0;
              transform: scale(.85);
              transform-origin: top right;
            }

            .hrn21v1 product-facet product-list a.product-item-meta__title{
              font-size: 16px !important;
              padding-right: 150px !important;
            }

            .hrn21v1 product-facet product-list .product-item-meta{
              height: auto !important;
              min-height: 180px;
            }

            .hrn21v1 product-facet product-list .product-item-meta p{
              margin: 0;
            }

            @media(max-width: 768px){
              .hrn21v1 product-facet product-list a.product-item-meta__title{
                font-size: 20px !important;
                padding-right: 0 !important;
                text-align: center !important;
              }
              .hrn21v1 product-facet product-list .product-item .product-item-meta__reviews-badge{
                position: static;
                transform: scale(1);
              }
            }

          </style>
        `);

        let prod_cards = document.querySelectorAll('product-list product-item');
        for (let i = 0; i < prod_cards.length; i++) {

          prod_cards[i].classList.add('js-hrn21-applied');

          //let reviews = prod_cards[i].querySelector('.product-item-meta__reviews-badge');
          let one_time_price = prod_cards[i].querySelector('.purchase-price');
          if (one_time_price) {
            one_time_price.classList.add("js-hidden");

            if (prod_cards[i].querySelectorAll('[id*="atc-"]:not(.js-upsell--subscribe)').length > 0) {
              let one_time_atc = prod_cards[i].querySelector('[id*="atc-"]:not(.js-upsell--subscribe)');
              one_time_atc.querySelector('.loader-button__text').innerHTML = `Add to Cart - ${one_time_price.innerHTML}`;

              if (prod_cards[i].querySelectorAll('.js-upsell--subscribe').length > 0) {
                let sub_atc_form = prod_cards[i].querySelector('.product-item__subscription-upsell');
                let sub_atc = prod_cards[i].querySelector('.js-upsell--subscribe');
                let sub_price = prod_cards[i].querySelector('.product-item__subscription-upsell .subscription-price');

                /*
                if(window.sessionStorage.getItem("HRN-27")){
                  //v1 is 50% off
                  let adjusted_sub_price = (sub_price.getAttribute("data-full-price")/200).toFixed(2);
                  sub_atc.querySelector('.loader-button__text').innerHTML = `Auto Renew It - ${adjusted_sub_price} First Order`;
                } else {
                  //v0 is 25% off
                  sub_atc.querySelector('.loader-button__text').innerHTML = `Auto Renew It - ${sub_price.innerHTML} First Order`;
                }
                */

                sub_atc_form.insertAdjacentHTML("afterend", `
                  <p style="text-align:center; padding-top: .75rem; font-size: 11px;">Auto-delivered every 30 days. Reschedule or cancel anytime.</p>
                `);
              }
            }
          }

        }
      }).catch();
    };

    //init
    apply_hrn21v1();

    document.addEventListener('pagination:page-changed', function (event) {
      apply_hrn21v1();
    });

  }).catch();

  waitUntil(() => {
    return window.sessionStorage.getItem("presidents-day");
  }).then(() => {

    waitUntil(() => {
      return document.querySelectorAll('cart-drawer#mini-cart free-shipping-bar').length > 0;
    }).then(() => {

      observeSelector('cart-drawer#mini-cart free-shipping-bar', fs_bar => {
        console.log("fs bar rebuilt...");

        fs_bar.querySelector('.shipping-bar__progress').classList.add("js-hidden");
        fs_bar.insertAdjacentHTML("afterend", `
          <style>
            .js-threshold-bar{
              position: relative;
            }
            .js-threshold-bar--container{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height:10px;
              border-radius: 15px;
              border: 2px solid #19327D;
            }
            .js-threshold-bar--fill{
              transition: .5s ease all;
              position: absolute;
              top: 1px;
              left: 1px;
              max-width: calc(100% - 1px);
              height:8px;
              border-radius: 15px;
              background: #19327D;
            }
            .js-threshold-goal{
              position: absolute;
              top: 0;
              left: 0;
              height: 10px;
              border-right: 2px solid #19327D;
            }
          </style>
          <div id="js-threshold-bar" class="js-threshold-bar">
            <div class="js-threshold-bar--container"></div>
            <div class="js-threshold-bar--fill" style="width: ${starting_threshold_percentage}%;"></div>
            <div class="js-threshold-goal" style="left: 57.14%;"></div>
            <div class="js-threshold-goal" style="left: 71.42%;"></div>
          </div>
        `);
        waitForElement('.js-threshold-bar--fill').then(fs_fill => {
          waitUntil(() => {
            return starting_threshold_percentage != threshold_percentage && threshold_percentage > 0;
          }).then(() => {

            if (cart_total_over_70) {
              document.documentElement.classList.add("js-auto-discount-active");
              window.sessionStorage.setItem("auto-apply-discount", "PREZ20");
              document.querySelector("free-shipping-bar .shipping-bar__text").innerHTML = `
                <strong>You get free shipping + $20 off!</strong>
              `;
            } else if (cart_total_over_50) {
              document.documentElement.classList.add("js-auto-discount-active");
              window.sessionStorage.setItem("auto-apply-discount", "PREZ10");
              document.querySelector("free-shipping-bar .shipping-bar__text").innerHTML = `
                <small>You get free shipping + $10 off!</small><br>
                Spend $${((7000 - cart_total) / 100).toFixed(2)} more to <strong>get $20 off</strong>
              `;
            } else {
              if (cart_total_over_40) {
                document.querySelector("free-shipping-bar .shipping-bar__text").innerHTML = `
                  <small>You get free shipping!</small><br>
                  Spend $${((5000 - cart_total) / 100).toFixed(2)} more to <strong>get $10 off</strong>
                `;
              }
              document.documentElement.classList.remove("js-auto-discount-active");
              window.sessionStorage.setItem("auto-apply-discount", "");
            }

            console.log("update fs bar...");
            setTimeout(() => {
              if (threshold_percentage >= 100) {
                // fs_fill.style.width = "calc(100% - 1px)";
                fs_fill.style.width = threshold_percentage + "%";
              } else {
                fs_fill.style.width = threshold_percentage + "%";
                fs_fill.style.borderRadius = "15px 0 0 15px";
              }
            }, 200);

          }).catch();

        }).catch();
      });

    }).catch();


  }).catch();

});

// override checkout action + apply discount styles
waitUntil(() => {
  return window.sessionStorage.getItem("auto-apply-discount");
}).then(() => {

  observeSelector('button[form="mini-cart-form"][type="submit"].checkout-button', checkout_btn => {

    checkout_btn.insertAdjacentHTML("beforebegin", `
    <style>
      .js-auto-discount-active button[form="mini-cart-form"][type="submit"].checkout-button{
        padding: 15px 0 25px 0;
      }

      .js-auto-discount-active #cart-total-price {
        position: relative;
        color: rgba(255, 255, 255, .9);
      }
      .js-auto-discount-active #cart-total-price:after {
        content: "";
        position: absolute;
        top: calc(50% - 2px);
        left: -5px;
        width: calc(100% + 10px);
        border-top: 2px solid #fff;
      }
      .js-auto-discount-active button[form="mini-cart-form"][type="submit"].checkout-button .loader-button__text:after {
          content: "discount calculated at checkout";
          position: absolute;
          font-size: 14px;
          text-align: center;
          right: 0;
          bottom: 7px;
          width: 100%;
          font-weight: 400;
          color: #fff;
          text-transform: none;
          font-family: Helvetica,'Helvetica Neue',Arial,'Lucida Grande',sans-serif;
        }
    </style>
  `);

    checkout_btn.addEventListener("click", (e) => {

      console.log("auto-apply discount ONLY for subs");

      let auto_apply_discount_code = window.sessionStorage.getItem("auto-apply-discount");

      let subs_in_cart = false;
      if (document.querySelectorAll('#mini-cart-form line-item[is-subscription-item]').length > 0) {
        subs_in_cart = true;
      }

      if (auto_apply_discount_code != "" && subs_in_cart) {
        e.preventDefault();
        window.location = `/discount/${auto_apply_discount_code}?redirect=/checkout`;
        e.stopImmediatePropagation();
      }
    });

  });

}).catch();


waitUntil(() => {

  return window.sessionStorage.getItem("HRN-17");

}).then(() => {

  init_experiment("HRN-17", "0.01", "v1");

  /*

  // reduce FOUC
  setTimeout(() => {
    document.body.classList.add("js-reveal");
  }, 200);

  */

  const redirect_list = {
    "/products/bar-soap": "/products/bar-soap-1",
    "/products/bar-soap-sandalwood": "/products/bar-soap-1?variant=39590376538215",
    "/products/bigger-3-kit": "/products/bigger-3-kit-2",
    "/products/bigger-3-kit-sandalwood": "/products/bigger-3-kit-2?variant=39590398853223",
    "/products/bigger-3-kit-bar-soap": "/products/bigger-3-kit-bar-soap-2",
    "/products/bigger-3-kit-bar-soap-sandalwood": "/products/bigger-3-kit-bar-soap-2?variant=39590401474663",
    "/products/body-wash": "/products/body-wash-2",
    "/products/body-wash-sandalwood": "/products/body-wash-2?variant=39590393872487",
    "/products/deodorant-original": "/products/deodorant",
    "/products/deodorant-sandalwood": "/products/deodorant?variant=39591527350375",
    "/products/jumbo-body-wash": "/products/jumbo-body-wash-2",
    "/products/jumbo-body-wash-sandalwood": "/products/jumbo-body-wash-2?variant=39578450002023",
    "/products/shower-kit-bar-soap": "/products/shower-kit-bar-soap-2",
    "/products/shower-kit-bar-soap-sandalwood": "/products/shower-kit-bar-soap-2?variant=39590396526695",
    "/products/the-shower-kit": "/products/shower-kit",
    "/products/the-shower-kit": "/products/shower-kit?variant=39590392889447",
    "/products/bar-soap-2-pack": "/products/bar-soap-2-pack-2",
    "/products/bar-soap-2-pack-sandalwood": "/products/bar-soap-2-pack-2?variant=39596296372327",
    "/products/body-duo-original": "/products/body-duo",
    "/products/body-duo-sandalwood": "/products/body-duo?variant=39596298109031",
    "/collections/all": "/collections/all-products",
    "/collections/body": "/collections/body-collection",
    "/collections/hair": "/collections/hair-collection",
    "/collections/face": "/collections/face-collection",
    "/collections/jumbos": "/collections/jumbo",
    "/collections/kits": "/collections/kits-collection",
    "/products/deodorant-scent-duo": "/products/deodorant-scent-duo-2",
    "/products/jumbo-shampoo": "/products/jumbo-shampoo-2",
    "/products/hair-duo": "/products/hair-duo-2",
    "/products/jumbo-conditioner": "/products/jumbo-conditioner-2",
    "/products/shampoo": "/products/shampoo-2",
    "/products/conditioner": "/products/conditioner-2",
    "/products/face-moisturizer": "/products/face-moisturizer-2",
    "/products/face-wash": "/products/face-wash-2",
    "/products/hair-styler": "/products/hair-styler-2"
  };

  let params = window.location.search.replace("?", "");
  let page_url = window.location.pathname.replace('https://usehuron.com', '');
  if (redirect_list[page_url]) {

    if (redirect_list[page_url].indexOf("?") > -1) {
      if (params.length > 0) {
        params = '&' + params;
      }
      window.location.href = redirect_list[page_url] + params;
    } else {
      if (params.length > 0) {
        params = '?' + params;
      }
      window.location.href = redirect_list[page_url] + params;
    }

  }

}).catch();


window.addEventListener('DOMContentLoaded', () => {

  // map combined products upsell
  let combined_upsells = document.querySelectorAll('.product-item__subscription-upsell.js-combined');
  for (let i = 0; i < combined_upsells.length; i++) {
    let prod_sku = combined_upsells[i].getAttribute("data-first-var-sku");
    // set form id
    combined_upsells[i].querySelector('form input[name="id"]').value = product_map[prod_sku].sub;
    // set data var
    combined_upsells[i].setAttribute("data-sub-var-id", product_map[prod_sku].sub);
  }

  waitUntil(() => {
    return document.querySelectorAll('.video-section external-video').length > 0;
  }).then(() => {
    setTimeout(() => {
      document.querySelector('.video-section external-video').style.transitionDelay = "0s";
    }, 2500);
  }).catch();

  //loading animations for reviews sections
  let reviews_timeout = false;
  waitUntil(() => {
    return document.querySelectorAll('.junip-product-review-title').length > 1 || reviews_timeout;
  }).then(() => {
    if (document.querySelectorAll('#reviews-loading-animation').length > 0) {
      document.querySelector('#reviews-loading-animation').innerHTML = "";
    }
  }).catch();

  setTimeout(() => {
    reviews_timeout = true;
  }, 10000);

  // setInterval(() => {
  //   if(document.body.classList.value.indexOf('rebuy') > -1){
  //     document.body.classList.remove('rebuy-modal-visible');
  //     console.log("remove rebuy class from body");
  //   }
  // }, 1500);

  //supernuke rebuy
  // const remove_rebuy_scripts = () => {
  //   waitUntil(() => {
  //     return document.querySelectorAll('script[src*="rebuy"]').length > 0;
  //   }).then(() => {
  //     let rebuy_scripts = document.querySelectorAll('script[src*="rebuy"]');
  //     for(let i = 0; i < rebuy_scripts.length; i++){
  //       rebuy_scripts[i].remove();
  //     }
  //     console.log("rebuy scripts removed", rebuy_scripts.length);
  //     remove_rebuy_styles();
  //     remove_rebuy_scripts();
  //   }).catch();
  // };
  // const remove_rebuy_styles = () => {
  //   waitUntil(() => {
  //     return document.querySelectorAll('link[href*="rebuy"]').length > 0;
  //   }).then(() => {
  //     let rebuy_styles = document.querySelectorAll('link[href*="rebuy"]');
  //     for(let i = 0; i < rebuy_styles.length; i++){
  //       rebuy_styles[i].remove();
  //     }
  //     console.log("rebuy styles removed", rebuy_styles.length);
  //     remove_rebuy_scripts();
  //     remove_rebuy_elements();
  //   }).catch();
  // };
  // const remove_rebuy_elements = () => {
  //   waitUntil(() => {
  //     return document.querySelectorAll('[id*="rebuy"]').length > 0;
  //   }).then(() => {
  //     let rebuy_elements = document.querySelectorAll('[id*="rebuy"]');
  //     for(let i = 0; i < rebuy_elements.length; i++){
  //       rebuy_elements[i].remove();
  //     }
  //     console.log("rebuy elements removed", rebuy_elements.length);

  //     let rebuy_scripts = document.querySelectorAll('script[src*="rebuy"]');
  //     for(let i = 0; i < rebuy_scripts.length; i++){
  //       rebuy_scripts[i].remove();
  //     }
  //     console.log("rebuy scripts removed (again)", rebuy_scripts.length);
  //     remove_rebuy_scripts();
  //     remove_rebuy_styles();
  //   }).catch();
  // };
  // remove_rebuy_scripts();
  // remove_rebuy_styles();
  // remove_rebuy_elements();

  //PDP trigger ATC link in content sections
  if (window.location.href.indexOf("/products/") > -1) {
    waitUntil(() => {
      return document.querySelectorAll('image-with-text .button--primary').length > 0;
    }).then(() => {


      waitForElement('#AddToCart').then(pdp_atc => {
        let buy_now_links = document.querySelectorAll('image-with-text .button--primary');
        for (let i = 0; i < buy_now_links.length; i++) {
          buy_now_links[i].addEventListener("click", (e) => {
            e.preventDefault();
            // pdp_atc.click()
            let scroll_to_pos = 0;
            if (window.innerWidth < 1000) {
              scroll_to_pos = pdp_atc.offsetTop - 400;
            }
            console.log("scroll to top", scroll_to_pos);

            window.scrollTo({ top: scroll_to_pos, behavior: 'smooth' });
          });
        }
      }).catch();

    }).catch();
  }

  /*

  js_loadScript("https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js", () => {
    console.log("jQuery re-loaded");

    //BFCM
    // ajax cart listener
    document.addEventListener('cart:updated', function(event) {
      let data = event.detail.cart; // Get the updated content of the cart
      // console.log(`cart total is ${data.total_price}`);
      if(data.total_price > 7000){
       window.sessionStorage.setItem("auto-apply-discount", "BF30");
      } else if(data.total_price > 4000){
       window.sessionStorage.setItem("auto-apply-discount", "BF20");
      } else {
       window.sessionStorage.setItem("auto-apply-discount", "");
      }
    });

  });

  */

  // v0 show signup, v1, hide signup
  waitUntil(() => {
    return window.sessionStorage.getItem("HRN-14") || getParam("qa").indexOf("hrn14") > -1;
  }).then(() => {
    waitForElement('#privy-container').then(privy => {

      // if either desktop or mobile Privy popup exists hide dismiss them
      waitUntil(() => {
        return document.querySelectorAll('[data-element-id="21092409"]').length > 0 || document.querySelectorAll('[data-element-id="21090786"]').length > 0;
      }).then(() => {
        // hide to reduce FOUC
        privy.setAttribute("style", "display:none !important");
        console.log("dismiss Privy popup");

        // close popup
        let privy_close = document.querySelectorAll('.privy-dismiss-content');
        for (let i = 0; i < privy_close.length; i++) {
          privy_close[i].click();
        }

        setTimeout(() => {
          privy.setAttribute("style", "display:block !important");
        }, 1500);

      }).catch();
    }).catch();

  }).catch();


  // create event listener for ATC element once it exists (on the success page)
  // desktop thank you = [data-element-id="21092389"]
  // mobile thank you = [data-element-id="21092109"]
  waitUntil(() => {
    return document.querySelectorAll('[data-link="#add-soap-bar-original"]').length > 0 || document.querySelectorAll('[data-link="#add-soap-bar-sandalwood"]').length > 0;
  }).then(() => {

    //success page reached
    console.log("HRN-14 -- Email Submission for Free Soap");
    ga('send', 'event', "Privy", "CRO", "Email Submission for Free Soap");

    let privy_close_elements = document.querySelectorAll('.privy-dismiss-content');
    const privy_close = () => {
      for (let i = 0; i < privy_close_elements.length; i++) {
        privy_close_elements[i].click();
      }
    };

    // element exists in Privy signup form
    let soap_atc_orig = document.querySelector('[data-link="#add-soap-bar-original"]');
    let soap_atc_sand = document.querySelector('[data-link="#add-soap-bar-sandalwood"]');

    soap_atc_orig.parentNode.style.zIndex = "10";
    soap_atc_sand.parentNode.style.zIndex = "10";

    const add_bar_to_cart = (var_id) => {
      // add bar
      cart_add_item(var_id, 1);

      // close popup
      privy_close();

      // auto apply discount code
      window.sessionStorage.setItem("auto-apply-discount", "BAR1");

      setTimeout(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        document.querySelector('[href="/cart"][aria-controls="mini-cart"]').click();
      }, 750);
    };

    soap_atc_orig.addEventListener("click", () => {
      console.log("add orig bar --- ")
      add_bar_to_cart(39482075152487);
    });

    soap_atc_sand.addEventListener("click", () => {
      console.log("add sand bar --- ")
      add_bar_to_cart(39503293677671);
    });

  }).catch();

  // override checkout action + apply discount styles
  waitUntil(() => {
    return window.sessionStorage.getItem("auto-apply-discount") && document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-actions').length > 0;
  }).then(() => {
    document.querySelector('#rebuy-cart').insertAdjacentHTML("beforebegin", `
	  <style>
		.rebuy-cart__flyout-item.product-bar-soap .rebuy-money {
          text-decoration: line-through;
          position: relative;
      	}
		.rebuy-cart__flyout-item.product-bar-soap .rebuy-money:after {
          content: "discount calculated at checkout";
          position: absolute;
          font-size: 12px;
          text-align: right;
          right: 0;
          bottom: -2em;
          width: 250px;
          font-weight: 400;
          color: #535353;
          text-transform: none;
          font-family: Helvetica,'Helvetica Neue',Arial,'Lucida Grande',sans-serif;
      	}
 	  </style>
	`);
    waitForElement('#rebuy-cart .rebuy-cart__flyout-actions #js-btn').then(js_btn => {
      js_btn.addEventListener("click", (e) => {
        let auto_apply_discount_code = window.sessionStorage.getItem("auto-apply-discount");
        e.preventDefault();
        window.location = `/discount/${auto_apply_discount_code}?redirect=/checkout`;
        e.stopImmediatePropagation();
      });
      js_btn.querySelector('span').innerHTML = `
      <i class="rebuy-button-icon prefix fas fa-lock"></i> Discount calculated at Checkout <i class=""></i>
      `;
    }).catch();
    waitForElement('#rebuy-cart .rebuy-cart__flyout-actions .rebuy-button').then(btn => {
      btn.addEventListener("click", (e) => {
        let auto_apply_discount_code = window.sessionStorage.getItem("auto-apply-discount");
        e.preventDefault();
        window.location = `/discount/${auto_apply_discount_code}?redirect=/checkout`;
        e.stopImmediatePropagation();
      });
      btn.querySelector('span').innerHTML = `
      <i class="rebuy-button-icon prefix fas fa-lock"></i> Discount calculated at Checkout <i class=""></i>
      `;
    }).catch();

  }).catch();

});

//----

let activate_hrn03 = false;
window.addEventListener('DOMContentLoaded', () => {

  const bundle_upsell_data = [
    {
      /* eye stick OOS -- eye stick 2.0 */
      base: [32856305500263],
      upsell: 39393111572583 /* face kit */
    },
    {
      /* face wash -- face moisturizer -- face lotion OOS */
      base: [21925748146265, 39320922456167],
      upsell: 39321012895847 /* bigger 3 kit */
    },
    {
      /* face wash (renew) -- face moisturizer (renew) -- face lotion (renew) OOS */
      base: [31776161759335, 39322366738535],
      upsell: 39322134151271 /* bigger 3 kit (renew) */
    },
    {
      /* bodywash -- shampoo -- conditioner -- hair duo */
      base: [31749123309671, 32881764073575, 32882314051687, 32981897936999],
      upsell: 32968703180903 /* shower kit */
    },
    {
      /* body wash (renew) -- shampoo (renew) -- conditioner (renew) -- hair duo (renew) */
      base: [32971065163879, 32982316810343, 32982316515431, 32982369632359],
      upsell: 39322370572391 /* shower kit (renew) */
    },
    {
      /* hair styler -- hair gel */
      base: [32882327421031, 32882279678055],
      upsell: 39393114751079 /* head and hair kit */
    },
    {
      /* jumbo body wash -- jumbo shampoo -- jumbo conditioner */
      base: [32408844075111, 32978606162023, 32978608521319],
      upsell: 39319783309415 /* jumbo shower kit */
    }
  ];

  const jumbo_upsell_data = [
    {
      base: [31749123309671], /* bodywash */
      upsell: 32408844075111 /* jumbo bodywash */
    },
    {
      base: [32881764073575], /* shampoo */
      upsell: 32978606162023 /* jumbo shampoo */
    },
    {
      base: [32882314051687], /* conditioner */
      upsell: 32978608521319 /* jumbo conditioner */
    }
  ];

  //hide elements until experiment is activated
  waitForElement('[data-rebuy-id="9608"]').then(jumbo_upsell => {
    waitForElement('[data-rebuy-id="10713"]').then(bundle_upsell => {
      jumbo_upsell.classList.add("js-inactive");
      bundle_upsell.classList.add("js-inactive");
    }).catch();
  }).catch();

  waitUntil(() => {
    return window.sessionStorage.getItem("HRN-03") || getParam("qa").indexOf("hrn03") > -1;
  }).then(() => {

    waitUntil(() => {
      return document.querySelectorAll('#rebuy-widget-10713').length > 0 && document.querySelectorAll('#rebuy-widget-9608').length > 0;
    }).then(() => {

      activate_hrn03 = true;
      init_experiment("HRN-03", "v0.06");

      waitForElement('#rebuy-cart .rebuy-cart__flyout').then(cart => {
        waitForElement('[data-rebuy-id="7053"]').then(frequently_purchased => {
          waitForElement('[data-rebuy-id="9608"]').then(jumbo_upsell => {
            waitForElement('[data-rebuy-id="10713"]').then(bundle_upsell => {

              let bundles_rebuy_widget = document.querySelector('#rebuy-widget-10713');
              let jumbos_rebuy_widget = document.querySelector('#rebuy-widget-9608');

              const update_rebuy_cart = () => {
                console.log("update_rebuy_cart()");

                if (variation === "v1") {
                  if (bundles_rebuy_widget.classList.value.indexOf("is-visible") > -1) {
                    frequently_purchased.classList.add("js-inactive");
                    bundle_upsell.classList.remove("js-inactive");
                  } else {
                    frequently_purchased.classList.remove("js-inactive");
                    bundle_upsell.classList.add("js-inactive");
                  }

                  setTimeout(() => {
                    get_cart_json().then(data => {
                      for (let i = 0; i <= data.items.length; i++) {
                        if (i === data.items.length) {
                          // console.log('no upsell items found', i);
                          return;
                        } else {
                          for (let ii = 0; ii < bundle_upsell_data.length; ii++) {
                            if (data.items[i].variant_id === bundle_upsell_data[ii].upsell) {
                              // console.log("item found", i);
                              cart_remove_items(bundle_upsell_data[ii].base);
                            }
                          }
                        }
                      }
                    });
                  }, 200);
                }

                if (variation === "v2") {
                  if (jumbos_rebuy_widget.classList.value.indexOf("is-visible") > -1) {
                    frequently_purchased.classList.add("js-inactive");
                    jumbo_upsell.classList.remove("js-inactive");
                  } else {
                    frequently_purchased.classList.remove("js-inactive");
                    jumbo_upsell.classList.add("js-inactive");
                  }
                }

                setTimeout(() => {
                  get_cart_json().then(data => {
                    for (let i = 0; i <= data.items.length; i++) {
                      if (i === data.items.length) {
                        // console.log('no upsell items found', i);
                        return;
                      } else {
                        for (let ii = 0; ii < jumbo_upsell_data.length; ii++) {
                          if (data.items[i].variant_id === jumbo_upsell_data[ii].upsell) {
                            // console.log("item found", i);
                            cart_remove_items(jumbo_upsell_data[ii].base);
                          }
                        }
                      }
                    }
                  });
                }, 200);
              };

              //init
              update_rebuy_cart();

              document.addEventListener("click", (e) => {
                setTimeout(() => {
                  update_rebuy_cart();
                }, 1500);
              });

            }).catch();
          }).catch();
        }).catch();
      }).catch();

    }).catch();
  }).catch();
});

//-----

let activate_hrn04 = true;
window.addEventListener('DOMContentLoaded', () => {

  waitUntil(() => {
    return window.sessionStorage.getItem("HRN-04") || getParam("qa").indexOf("hrn04") > -1;
  }).then(() => {

    activate_hrn04 = true;
    init_experiment("HRN-04", "v0.01");

    //update auto_apply to 50% off first time subs
    waitUntil(() => {
      return window.sessionStorage.getItem("subs_discount_code") && document.documentElement.classList.value.indexOf("hrn05") > -1;
    }).then(() => {
      window.sessionStorage.setItem("subs_discount_code", "newsubsave50");
      if (window.location.href.indexOf('/products/') > -1) {
        //is PDP
        waitForElement('label.selector-item[for="subscription"] h4').then(sub_label => {
          sub_label.innerText = sub_label.innerText.replace("Subscribe", "Auto Deliver");
        }).catch();
      }
    }).catch();

    waitForElement('h1#variant_price').then(price => {

      let prod_price = parseFloat(price.innerText.replace("$", ""));
      let fifty_percent = (prod_price * .5).toFixed(2)
      let fifteen_percent = (prod_price * .15).toFixed(2);

      waitForElement('#one-time-selector label h4').then(one_time => {
        one_time.insertAdjacentHTML("beforeend", `<span class="js-price"> - ${price.innerText}</span>`);
      }).catch();

      waitForElement('label[for="subscription"]').then(subs_label => {
        subs_label.querySelector("div > h4").innerHTML = `Subscribe - Save $${fifty_percent} on your first order.<br>
        <small>Save $${fifteen_percent} on every order after that</small>`;
      }).catch();

    }).catch();

  }).catch()

});

//-----

// let activate_hrn05 = true;
// window.addEventListener('DOMContentLoaded', () => {

//   window.sessionStorage.setItem("HRN-05", "v1");

//   waitUntil(() => {
//     return window.sessionStorage.getItem("HRN-05") || getParam("qa").indexOf("hrn05") > -1;
//   }).then(() => {

//     activate_hrn05 = true;
//     init_experiment("HRN-05", "v0.01");

//     //subscriptions have code "freeshipping" auto-applied
//     window.sessionStorage.setItem("subs_discount_code", "freeshipping");

//     //rebuy takes too long and times out
//     waitUntil(() => {
//       return document.querySelectorAll('#rebuy-cart .rebuy-cart__flyout-actions .rebuy-button').length > 0;
//     }).then(() => {
//       waitForElement('#rebuy-cart .rebuy-cart__flyout-actions .rebuy-button').then(checkout_btn => {
//         checkout_btn.classList.add("js-hidden");
//         checkout_btn.insertAdjacentHTML("beforebegin", `
//           <a id="js-btn" class="js-checkout-button">
//             <span><i class="rebuy-button-icon prefix fas fa-lock"></i> Checkout <i class=""></i></span>
//           </a>
//         `);

//         waitForElement('#js-btn').then(btn => {
//           let discount_code = window.sessionStorage.getItem("subs_discount_code");
//           btn.addEventListener("click", (e) => {
//             e.preventDefault();
//             $.ajax({
//               type: 'GET',
//               url: '/cart.js',
//               dataType: 'json',
//               success: function (data) {
//                 console.log(data);
//                 if (data.items.length > 0) {

//                   for (let i = 0; i <= data.items.length; i++) {
//                     if (i === data.items.length) {
//                       // console.log('no subs found', i);
//                       window.location = "/checkout";
//                     } else {

//                       if (data.items[i].properties && data.items[i].properties.shipping_interval_frequency) {
//                         // console.log("subs found in item", i);
//                         function get_cookie(name) {
//                           return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2];
//                         }
//                         let token = get_cookie('cart');
//                         let checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + Shopify.shop + "&cart_token=" + token + "&discount=" + discount_code;
//                         window.location = checkout_url;
//                         return;
//                       } else {
//                         // console.log('has properties, not sub tho', i);
//                         // window.location = "/checkout";
//                       }

//                     }
//                   }

//                 }
//               }
//             });
//           });
//         }).catch();

//       }).catch();

//     }).catch();
//   }).catch()

// });

//-----

//kill rebuy stylesheet
waitForElement('link[href="https://cdn.rebuyengine.com/onsite/css/global.min.1637080955.css"]').then(el => {
  el.remove();
}).catch();

/*

waitUntil(() => {
  return window.sessionStorage.getItem("HRN-08") || getParam("qa").indexOf("hrn08") > -1;
}).then(()=> {

  init_experiment("HRN-08", "v0.2");
  // treatment is also an interation of HRN-04 which is a PDP test
  init_experiment("HRN-04", "v0.01");
  window.sessionStorage.setItem("subs_discount_code", "newsubsave50");

  if (window.location.pathname.match('collections')) {

    // document.body.classList.add('HRN-collections-subscribe');

    const productList = {
      "39321012895847" : "39322134151271"  //Bigger 3 kit
      ,"32968703180903" : "39322370572391" //Shower kit
      ,"32981897936999" : "32982369632359" //Hair Duo
      ,"32408844075111" : "32971065163879" //Jumbo Body Wash
      ,"32978606162023" : "32982375071847" //Jumbo Shampoo
      ,"32978608521319" : "32982375039079" //Jumbo Conditioner
      ,"31749123309671" : "31776160088167" //Body Wash
      ,"32881764073575" : "32982316810343" //Shampoo
      ,"32882314051687" : "32982316515431" //Conditioner
      ,"21925748146265" : "31776161759335" //Face wash
      // ,"32856305500263" : "39283692011623" //Eye stick
      ,"39320922456167" : "39322366738535" //Face moisturizer
      ,"32882279678055" : "32982316712039" //Hair Gel
      ,"32882327421031" : "32982326018151" //Hair Styler
      ,"39482075152487" : "39482076561511" //Bar Soap
      ,"39483098693735" : "39483348451431" //Bar Soap - 2 Pack
      ,"39479943037031" : "39480671174759" //Bigger 3 Kit - Bar Soap
      ,"39479912661095" : "39480673173607" //Shower Kit - Bar Soap
      ,"39516818702439" : "39517160734823" //shower-kit-sandalwood-black-pepper
      ,"39516832792679" : "39517175316583" //shower-kit-bar-soap-sandalwood-black-pepper
      ,"39513546981479" : "39516011298919" //jumbo-body-wash-sandalwood-black-pepper
      ,"39516781248615" : "39517133963367" //bar-soap-2-pack-sandalwood-black-pepper
      ,"39516934996071" : "39517178691687" //bigger-3-kit-sandalwood-black-pepper
      ,"39516941189223" : "39517180166247" //bigger-3-kit-bar-soap-sandalwood-black-pepper
      ,"39503293677671" : "39516013068391" //bar-soap-sandalwood-black-pepper
      ,"39503269757031" : "39518654136423" //body-wash-sandalwood-black-pepper
      //,"39319783309415" : "xxx" //Jumbo Shower
    }

    observeSelector('.product-list__inner .product-item', product_item => {

      waitUntil(() => {
        return product_item.querySelectorAll('form input[name="id"]').length > 0;
      }).then(() => {

        let product_id = product_item.querySelector('form input[name="id"]').value;
        if (productList[product_id]) {
          //has subscription model
          let product_price = product_item.getAttribute("data-purchase-price");
          product_item.querySelector('.product-item__info').insertAdjacentHTML("beforeend", `
            <hr>
            <p>Set it and forget it. <strong>Save $${(product_price*.005).toFixed(2)}</strong> on your first order.</p>

            <form method="post" action="/cart/add" enctype="multipart/form-data" is="product-form">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <input type="hidden" name="quantity" value="1">
              <input type="hidden" name="id" value="${productList[product_id]}">

              <input type="hidden" name="properties[shipping_interval_unit_type]" value="Days">
              <input type="hidden" name="properties[shipping_interval_frequency]" value="60">

              <button is="loader-button" type="submit" class="button button--outline button--text button--full js-upsell--subscribe">
                <span class="loader-button__text">+ Auto Renew It</span>
                <span class="loader-button__loader" hidden="">
                  <div class="spinner">
                    <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                      <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                    </svg>
                  </div>
                </span>
              </button>

            </form>

          `);


          let sub_btn = product_item.querySelector('.js-upsell--subscribe');
          if (product_item.classList.value.indexOf('product-item--sold-out') > -1) {
            sub_btn.disabled = "true";
          } else {
            sub_btn.classList.add('disabled');
          }

        } else {
          product_item.classList.add('adjust-height');
        }

      }).catch();

    });
  }//collections

}).catch();

*/

/*
START ShipScout free shipping status bar override
*/

/*
document.addEventListener("DOMContentLoaded", () => {
  document.querySelector('body').insertAdjacentHTML("afterbegin", `
  <style>
    .announcement-bar div {
      opacity: 0;
      transition: .5s ease all;
    }
    .announcement-bar.js-active div{
      opacity: 1;
    }
  </style>
  `);
});
*/

window._shipScout = window._shipScout || [];
_shipScout.push(function (response) {

  let threshold_amount = response.freeShippingThresholdCents;

  if (response.variant) {
    // all announcement bar items
    let announcement_items = document.querySelectorAll('announcement-bar-item p');
    for (let i = 0; i < announcement_items.length; i++) {
      if (announcement_items[i].innerHTML.indexOf('Orders Over $40') > -1 || announcement_items[i].innerHTML.indexOf('ORDERS OVER $40') > -1) {
        announcement_items[i].innerHTML = `Get Free Shipping On All Orders Over $${(threshold_amount / 100).toFixed(0)}`;
      }
      if (i == announcement_items.length - 1) {
        document.querySelector('.announcement-bar').classList.add("js-active");
      }
    }
  } else {
    document.querySelector('.announcement-bar').classList.add("js-active");
  }

});

waitForElement('.mini-cart__drawer-footer').then(mini_cart_footer => {

  let prev_total = mini_cart_footer.getAttribute("data-cart-total");

  observeSelector('free-shipping-bar', fs_bar => {

    // IF THERE IS AN ACTIVE SHIPSCOUT TEST --> override the free shipping status bar in the ajax cart with updated threshold value

    window._shipScout = window._shipScout || [];
    _shipScout.push(function (response) {

      if (response.testId && document.querySelectorAll('#js-fs--progress').length == 0) {

        console.log("ShipScout test is active", `${response.variant}: $${(response.freeShippingThresholdCents / 100).toFixed(2)} threshold`);
        ga('send', 'event', 'CRO', 'ShipScout', `${response.variant}: $${(response.freeShippingThresholdCents / 100).toFixed(2)} threshold`);

        let thresholdCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.freeShippingThresholdCents * Shopify.currency.rate : response.freeShippingThresholdCents;

        document.querySelector('body').insertAdjacentHTML("afterbegin", `
          <style>
          free-shipping-bar{
            display: none;
            opacity: 0;
            position: absolute;
            left: -9999px;
          }

          .js-fs--container{
            margin-top: 1rem;
          }
          .js-fs--text{
            text-align: center;
          }
          .js-fs--bar{
            border: 2px solid #19327d;
            border-radius: 20px;
            padding: 3px;
            position: relative;
          }
          .js-fs--progress{
            position: absolute;
            top:0;
            left: 0;
            height: 100%;
            background: #19327d;
            transition: .25s ease all;
          }
          </style>
        `);

        let cart_total = document.querySelector('.mini-cart__drawer-footer').getAttribute("data-cart-total");

        let threshold_amount = response.freeShippingThresholdCents;

        console.log("update_freeshipping_progress", cart_total, threshold_amount);

        let fs_percent, fs_prev_percent, fs_text;

        if (prev_total / threshold_amount > 1) {
          fs_prev_percent = "100%";
        } else {
          fs_prev_percent = `${((prev_total / threshold_amount) * 100).toFixed(2)}%`;
        }

        if (cart_total / threshold_amount > 1) {
          fs_percent = "100%";
          fs_text = "You are now eligible for free shipping!"
        } else {
          fs_percent = `${((cart_total / threshold_amount) * 100).toFixed(2)}%`;
          fs_text = `Spend $${((threshold_amount - cart_total) / 100).toFixed(2)} more and get free shipping!`;
        }


        fs_bar.insertAdjacentHTML("beforebegin", `
          <div class="js-fs--container">
            <div id="js-fs--text" class="js-fs--text shipping-bar__text text--small">
              ${fs_text}
            </div>
            <div class="js-fs--bar">
              <div id="js-fs--progress" class="js-fs--progress" style="width: ${fs_prev_percent};"></div>
            </div>
          </div>
        `);

        waitForElement('#js-fs--progress').then(js_progress => {
          setTimeout(() => {
            js_progress.style.width = `${fs_percent}`;
          }, 100);
        }).catch();

        prev_total = cart_total;

      } else {
        console.log("no active ShipScout test");
      }
    });
  });

}).catch();

/*
END ShipScout free shipping status bar override
*/
